import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import { store } from "../../util/store";
import ReusableAgGrid from "../AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const DrilldownBody = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  const classes = useStyle();
  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID);

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={12}
          >
            <Grid
              item
              container
              xs={10}
              justify="flex-start"
              alignItems="flex-end"
            >
              {props.isMetaData ? (
                <>
                  <Typography
                    variant="body1"
                    style={{ fontWeight: "600", padding: "0.3rem" }}
                  >
                    <>Added in the past {props.metaData[3].value} weeks</>
                    &nbsp;&nbsp;&nbsp;&nbsp; # of Opps:{" "}
                    <span data-test="baseInfo-count">
                      {d3.format(",")(props.body.count_acv[0].count)}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp{acvLabel}: {`${Currency_Symbol}`}
                    <span data-test="baseInfo-acv">
                      {d3.format(",")(Math.round(props.body.count_acv[0].acv))}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <>
                      Avg. deal size: {`${Currency_Symbol}`}
                      <span data-test="baseInfo-avgAcv">
                        {d3.format(",")(
                          Math.round(props.body.count_acv[0].avg)
                        )}
                      </span>
                    </>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trailing
                    average&nbsp;&nbsp;&nbsp;
                    <>
                      # of Opps:{" "}
                      <span data-test="averageInfo-count">
                        {props.body.count_acv[0].count_avg.toFixed(1)}
                      </span>
                    </>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    <>
                      {acvLabel}: {`${Currency_Symbol}`}
                      <span data-test="averageInfo-acv">
                        {d3.format(",")(
                          Math.round(props.body.count_acv[0].acv_avg)
                        )}
                      </span>
                    </>
                  </Typography>
                </>
              ) : ![null, undefined, ""].includes(props.fromStage) ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {acvLabel}:{" "}
                  {`${Currency_Symbol}`}
                  <span data-test="acv">
                    {d3.format(",")(Math.round(props.body.count_acv[0].acv))}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avg. Deal Size:{" "}
                  {`${Currency_Symbol}`}
                  <span data-test="avg-deal-size">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].avg_deal_size)
                    )}
                  </span>{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avg.{" "}
                  {props.fromStage} to {props.winStage} Cycle Time:{" "}
                  <span data-test="avg-win-cycle-time">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].avg_win_time)
                    )}
                  </span>
                </Typography>
              ) : (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {acvLabel}:{" "}
                  {`${Currency_Symbol}`}
                  <span data-test="acv">
                    {d3.format(",")(Math.round(props.body.count_acv[0].acv))}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avg. Deal Size:{" "}
                  {`${Currency_Symbol}`}
                  <span data-test="avg-deal-size">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].avg_deal_size)
                    )}
                  </span>{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Avg. Qualifying to
                  Win Cycle Time:{" "}
                  <span data-test="avg-qualifying-to-wct">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].avg_win_time)
                    )}
                  </span>
                </Typography>
              )}
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={2}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={props.body.opportunities}
            columnConfig={props.body.columns}
            onCellClicked={onCellClicked}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default DrilldownBody;
